<ng-container *ngIf="vm$ | async as vm">
  <div class="flex-auto flex flex-column self-start simple-selector">
    <jb-form-field-container class="traveler-options">
      <jb-select-button
        #jbSelectButton
        type="simple"
        [id]="vm.travelerSelectorId"
        [placeholder]="vm.content.travelers || 'travelers' "
        [hasError]="!!vm.travelerCountError?.length"
        [value]="vm.travelersSummary.compact"
        flyoutRef="flyoutFormControl"
      >
        <jb-flyout
          #flyoutFormControl
          [placement]="vm.placement"
          [fullscreenOnPhone]="true"
          [verticalFlipping]="false"
          [horizontalFlipping]="true"
          offsetY="8"
        >
          <div class="flex flex-column flex-none-ns w-100">
            <header
              class="w-100 dn-ns flex items-center bg-core-blue ph3 relative"
            >
              <h4 class="center mb0 white">{{ vm.content.travelers || 'Travelers'}}</h4>
              <jb-close-button
                class="mv-11"
                size="large"
                aria-label="Close Dialog"
                (click)="flyoutFormControl.close()"
              ></jb-close-button>
            </header>
            <div
              class="pv5 ph3 pa3-ns h-100 overflow-y-auto overflow-y-hidden-ns"
            >
              <div class="db bb pb3 dn-ns total">
                <span class="db f7 mb2 slate-gray">{{
                  vm.content.travelers || 'Travelers'
                }}</span>
                <p class="royal-blue">
                  {{ vm.travelersSummary.full }}
                </p>
              </div>
              <div *ngIf="vm.options.multipleGroups" class="rooms-mt3-s pb3">
                <jb-incrementer
                  [formControl]="roomsControl"
                  [label]="vm.content.rooms || 'Rooms'"
                  [min]="1"
                  [max]="vm.maxGroups"
                  [fluidWidth]="true"
                  decreaseLabel="remove room"
                  increaseLabel="add room"
                ></jb-incrementer>
              </div>
              <ng-container
                *ngFor="
                  let travelerGroupControl of travelerGroupsControl.controls;
                  let index = index
                "
              >
                <h5
                  class="bg-off-white pa2 mb2 fix-margin"
                  *ngIf="vm.options.multipleGroups"
                >
                  {{ vm.content.room || 'Room' }} {{ index + 1 }}
                </h5>
                <dot-traveler-group
                  [formControl]="travelerGroupControl"
                  [requireChildAges]="vm.options.requireChildAges"
                  [content]="vm.content"
                  [travelerAllowedRange]="vm.travelerAllowedRange[index]"
                >
                </dot-traveler-group>
              </ng-container>

              <ul class="list pl0 rules" *ngIf="!!vm.rules?.length">
                <li
                  *ngFor="let rule of vm.rules; let i = index"
                  class="f6 lh-copy"
                >
                  <span [ngClass]="rule.warn ? 'fw7' : 'normal'">
                    {{ rule.copy }}
                  </span>
                </li>
              </ul>
              <span
                *ngIf="!!vm.content.help?.content"
                class="s-body"
                [innerHtml]="vm.content.help.content"
                jbSmartLink
              ></span>
            </div>
            <button
              class="traveler-continue-button dn-ns self-end br0-important"
              jbButton
              theme="ctaPrimary"
              (click)="flyoutFormControl.close()"
            >
            {{vm.content.continue || 'Continue'}}
            </button>
          </div>
        </jb-flyout>
      </jb-select-button>
      <jb-error
        *ngFor="let error of travelerGroupsControl.errors | keyvalue"
        [forError]="error.key"
        [showErrorIf]="vm.showValidationErrors || travelerGroupsControl.touched"
        aria-live="polite"
      >
        <span aria-hidden="true">{{ error.value }}</span>
        <jb-sr-only>Error: {{ error.value }}</jb-sr-only>
      </jb-error>
    </jb-form-field-container>
  </div>
</ng-container>
